import { css } from '@/styled-system/css';

export const menuHeadingStyles = css.raw({
  'textStyle': 'body-sm-bold',
  'color': 'text.subtle',
  'textTransform': 'uppercase',
  'paddingBlock': 'tight',
  'paddingInline': 'default',
  'backgroundColor': 'Menu.Heading.bg',
  'display': 'flex',
  'alignItems': 'center',
  'gap': 'tighter',

  '& > .c11n_icon': {
    color: 'icon.subtle',
    width: 'icon.md',
    height: 'icon.md',
  },
});
